module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-stone-path.ad6b19e1.png";